import React from "react"
import "./App.css"
import Routes from "./routes"
import { toast } from "react-toastify";
function App() {
  toast.configure()
  return (
    <div>
      <Routes />
    </div>
  )
}
export default App


// REACT_APP_LIVE_URL=https://uczhbpqkk3.execute-api.us-east-2.amazonaws.com/production



// WEBPACK FOOTER //
// ./src/App.js